/**
 * # 背景音乐：JourneyToWest（云宫迅音）
 *
 * 改编自 86 版《西游记》经典片头曲《云宫迅音》， 以方波音色配合附点节奏，重现标志性的"丢丢丢丢"旋律。
 *
 * ## 曲式结构
 *
 * | 段落     | 风格             | 说明                       |
 * | -------- | ---------------- | -------------------------- |
 * | 前奏     | 标志性"丢丢丢丢" | 高音区重复音型，穿插休止符 |
 * | 主旋律   | 附点节奏 3-1-1   | 经典旋律，附点节奏感强     |
 * | 冲上云霄 | 音区拔高         | 情绪推进，音高上移         |
 * | 转折     | 回落             | 音区下移，趋于平稳         |
 * | 燃段     | 密集推进         | 音符更密集，情绪高涨       |
 * | 回响     | 超高音           | 极高音区，短暂有力         |
 * | 结尾     | 低音收束         | 回到低音区，渐慢收尾       |
 *
 * ## 音乐参数
 *
 * | 参数     | 值     | 说明                               |
 * | -------- | ------ | ---------------------------------- |
 * | duration | 110    | 每个音符的基准时长（ms），较慢节奏 |
 * | volume   | 0.12   | 音量（0-1），比其他曲目更响亮      |
 * | wave     | square | 波形（方波，经典 8-bit 音色）      |
 *
 * @constant {object} JourneyToWest
 */
const JourneyToWest = {
  /** ## 音乐名称 */
  name: 'JourneyToWest',

  /**
   * ## 旋律数据
   *
   * 每个音符包含：
   *
   * - `freq`：频率（Hz），0 表示休止符
   * - `dur`：时长系数（乘以 duration 得到实际时长）
   *
   * @type {{ freq: number; dur: number }[]}
   */
  melody: [
    // ===== 前奏：标志性的"丢丢丢丢" =====
    { freq: 880, dur: 1.2 },
    { freq: 880, dur: 1.2 },
    { freq: 0, dur: 0.6 }, // 休止
    { freq: 880, dur: 1.2 },
    { freq: 880, dur: 1.2 },
    { freq: 0, dur: 0.6 },
    { freq: 880, dur: 1.2 },
    { freq: 880, dur: 1.2 },
    { freq: 0, dur: 0.6 },
    { freq: 880, dur: 1.2 },
    { freq: 880, dur: 2.4 },

    // ===== 主旋律（附点节奏 3-1-1）=====
    { freq: 440, dur: 3.6 },
    { freq: 440, dur: 0.9 },
    { freq: 440, dur: 2.7 },
    { freq: 523, dur: 3.6 },
    { freq: 587, dur: 3.6 },
    { freq: 587, dur: 0.9 },
    { freq: 587, dur: 2.7 },
    { freq: 659, dur: 4.5 },

    // ===== 冲上云霄 =====
    { freq: 880, dur: 3.6 },
    { freq: 880, dur: 0.9 },
    { freq: 880, dur: 2.7 },
    { freq: 784, dur: 3.6 },
    { freq: 659, dur: 3.6 },
    { freq: 659, dur: 0.9 },
    { freq: 659, dur: 2.7 },
    { freq: 659, dur: 4.5 },

    // ===== 转折 =====
    { freq: 587, dur: 3.6 },
    { freq: 587, dur: 0.9 },
    { freq: 587, dur: 2.7 },
    { freq: 523, dur: 3.6 },
    { freq: 440, dur: 3.6 },
    { freq: 440, dur: 0.9 },
    { freq: 440, dur: 2.7 },
    { freq: 440, dur: 4.5 },

    // ===== 燃段 =====
    { freq: 587, dur: 2.7 },
    { freq: 587, dur: 1.8 },
    { freq: 659, dur: 2.7 },
    { freq: 784, dur: 3.6 },
    { freq: 784, dur: 1.8 },
    { freq: 784, dur: 1.8 },
    { freq: 880, dur: 3.6 },
    { freq: 988, dur: 2.7 },
    { freq: 988, dur: 1.8 },
    { freq: 988, dur: 2.7 },
    { freq: 880, dur: 3.6 },
    { freq: 784, dur: 2.7 },
    { freq: 784, dur: 1.8 },
    { freq: 784, dur: 3.6 },

    // ===== 回响：超高音 =====
    { freq: 1175, dur: 1.4 },
    { freq: 1175, dur: 1.4 },
    { freq: 0, dur: 0.9 },
    { freq: 1175, dur: 1.4 },
    { freq: 1175, dur: 1.4 },
    { freq: 0, dur: 0.9 },
    { freq: 880, dur: 2.7 },
    { freq: 880, dur: 2.7 },

    // ===== 结尾 =====
    { freq: 440, dur: 3.6 },
    { freq: 440, dur: 1.8 },
    { freq: 440, dur: 3.6 },
    { freq: 440, dur: 1.8 },
    { freq: 440, dur: 5.4 },
  ],

  /** ## 每个音符的基准时长（ms），较慢节奏 */
  duration: 110,

  /** ## 音量（0-1），比其他曲目更响亮 */
  volume: 0.12,

  /** ## 波形类型：方波（经典 8-bit 音色） */
  wave: 'square',
};

export default JourneyToWest;
